import React from 'react'
import NumericInput, { NumericInputProps } from 'react-numeric-input'

const defaultProps = {
  noStyle: true,
  value: '',
  precision: 0,
  autoComplete: 'off',
}

const InputNumeric: React.FC<NumericInputProps> = (props) => {
  return <NumericInput {...props} inputMode='numeric' />
}

InputNumeric.defaultProps = defaultProps

export default InputNumeric